import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%'
  },
  header: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(8)
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'baseline'
  },
  title: {
    color: theme.colorPalette.green_90,
    fontFamily: theme.typography.fontFamily,
    fontSize: 24,
    fontWeight: 400,
    lineHeight: '32px'
  },
  totalContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  totalWord: {
    marginLeft: theme.spacing(2),
    color: theme.colorPalette.beige_75,
    fontSize: 10,
    fontWeight: 600
  },
  totalValue: {
    color: theme.colorPalette.green_75,
    fontSize: 10,
    fontWeight: 600,
    marginLeft: theme.spacing(2)
  },
  totalCount: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  },
  openButton: {
    textTransform: 'none'
  },
  imageIcon: {
    fontSize: '1.2rem'
  },
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  openAllImagesButton: {
    fontSize: 14,
    fontWeight: 600,
    padding: 0
  },
  reviewImagesIcon: {
    marginLeft: theme.spacing(2)
  }
}));

export default useStyles;
